// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"721":"28efd8eb","777":"recorder"}[chunkId] || chunkId) + "." + {"403":"bfbd4a41adca6bcb","719":"32428b443459f73f","721":"32e3c3239ef0a257","777":"ceb8c986fb7e4e00"}[chunkId] + ".js";
};